import * as XLSX from 'xlsx-js-style'
import colors from 'Theme/colors'

// Same look as the Laporan Ketelusuran export (mutation-report), theme colours only
const hex = (value) => value.replace('#', '').toUpperCase()

const COLOR = {
  text: hex(colors.neutral[700]),
  line: hex(colors.neutral[200]),
  zebra: hex(colors.neutral[50]),
  white: hex(colors.white),
  header: hex(colors.primary[500]),
}

const side = { style: 'thin', color: { rgb: COLOR.line } }
const border = { top: side, bottom: side, left: side, right: side }
const font = (extra = {}) => ({
  name: 'Calibri',
  sz: 10,
  color: { rgb: COLOR.text },
  ...extra,
})

const cellText = (cell) => {
  if (!cell || cell.v === undefined || cell.v === null) return ''
  return cell.w ?? String(cell.v)
}

/**
 * Styles a plain table sheet in place: coloured bold header row(s) at the top,
 * borders, zebra rows, thousand separator on numeric cells and column widths
 * fitted to the content.
 */
export const styleTableSheet = (sheet, { headerRows = 1 } = {}) => {
  if (!sheet?.['!ref']) return sheet
  const range = XLSX.utils.decode_range(sheet['!ref'])
  const widths = []

  for (let r = range.s.r; r <= range.e.r; r += 1) {
    const isHeader = r < headerRows
    for (let c = range.s.c; c <= range.e.c; c += 1) {
      const address = XLSX.utils.encode_cell({ r, c })
      if (!sheet[address]) sheet[address] = { t: 's', v: '' }
      const cell = sheet[address]

      if (cell.t === 'n' && !cell.z) {
        cell.z = Number.isInteger(cell.v) ? '#,##0' : '#,##0.00'
      }

      cell.s = isHeader
        ? {
            font: font({ bold: true, color: { rgb: COLOR.white } }),
            fill: { patternType: 'solid', fgColor: { rgb: COLOR.header } },
            alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
            border,
          }
        : {
            font: font(),
            ...((r - headerRows) % 2 === 1 && {
              fill: { patternType: 'solid', fgColor: { rgb: COLOR.zebra } },
            }),
            alignment: { vertical: 'top', wrapText: true },
            border,
          }

      // Longest line in the cell, so multi-line notes don't blow up the width
      const longest = Math.max(...cellText(cell).split('\n').map((l) => l.length))
      widths[c] = Math.max(widths[c] ?? 0, longest)
    }
  }

  if (!sheet['!cols']) {
    sheet['!cols'] = widths.map((w) => ({ wch: Math.min(Math.max(w + 2, 10), 50) }))
  }
  sheet['!rows'] = sheet['!rows'] || []
  for (let r = 0; r < headerRows; r += 1) sheet['!rows'][r] = { hpx: 24 }

  return sheet
}
